export const Types = {
  TOGGLE_MOBILE_MENU: 'TOGGLE_MOBILE_MENU',
}
